<template>
  <div class="comp-template fit-height">
    <div v-if="TEMPLATE">
      <div class="template-head details-head">
        <div class="inn">
          <div class="info">
            <ul class="meta">
              <li>Template #{{ TEMPLATE.id }}</li>
            </ul>
            <div class="title">
              <template v-if="editTemplateName">
                <form method="post" action="" @submit.prevent="updateName">
                  <input type="text" class="form-control" v-model="newTemplateName" ref="inputName" @blur="updateName">
                </form>
              </template>
              <template v-else>
                <span>{{ TEMPLATE.name }}</span>
                <a href="javascript:;" class="edit icon-pencil"
                   @click="editTemplateName = true"></a>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="auto-height">
        <div class="form-row">
          <label class="lb">FROM NAME</label>
          <div class="inputs">
            <input class="form-control" v-model="postData.from_name" />
          </div>
        </div>
        <div class="form-row">
          <label class="lb">FROM EMAIL</label>
          <div class="inputs">
            <input type="email" class="form-control" v-model="postData.from_email" />
          </div>
        </div>
        <div class="form-row">
          <label class="lb">EMAIL SUBJECT</label>
          <div class="inputs">
            <input class="form-control" v-model="postData.email_subject" />
          </div>
        </div>
        <div class="form-group">
          <label class="lb">EMAIL BODY</label>
          <editor :api-key="tinyApiKey" :init="tinyOpts" v-model="postData.email_body"></editor>
        </div>
        <div class="text-right">
          <beat-loader v-if="state == 'saving'"></beat-loader>
          <template v-else>
            <button type="button" class="btn btn btn-primary w180" @click="saveTemplate(null)">Save</button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import {mapGetters,mapState} from 'vuex'
  import BeatLoader from 'vue-spinner/src/BeatLoader'
  import ServiceTemplate from '@/services/emailtemplate'
  import Editor from '@tinymce/tinymce-vue'

  export default {
    components: {
      BeatLoader,
      Editor
    },
    data() {
      return {
        state: '',
        status: 'pending',
        updated_dtm: 0,
        editTemplateName: false,
        newTemplateName: '',
        postData: {
          from_name: '',
          from_email: '',
          email_subject: '',
          email_body: ''
        },
        tinyOpts: {height : 450, plugins: 'code', toolbar: 'code'}
      }
    },
    props: ['templateId'],
    watch: {
      templateId(newVal) {
        if (newVal && this.TEMPLATE && this.TEMPLATE.id != newVal)
          this.init();
      },
      editTemplateName(newVal) {
        let self = this;
        if (newVal) {
          self.newTemplateName = self.TEMPLATE.name;
          setTimeout(() => {
            self.$refs.inputName.focus();
          }, 200);
        }
      }
    },
    computed: {
      ...mapGetters(['TEMPLATE']),
      ...mapState({
        tinyApiKey: state => state.option.tinyApiKey
      }),
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        let self = this;
        self.$store.dispatch('GET_TEMPLATE', self.templateId)
          .then(() => {
            self.populateData();
          });
      },
      populateData() {
        let self = this;
        for(let f in self.postData){
          if(typeof self.TEMPLATE[f] != 'undefined')
            self.postData[f] = self.TEMPLATE[f];
        }
      },
      updateName() {
        let self = this;
        // save to DB
        setTimeout(() => {
          if (self.newTemplateName != self.TEMPLATE.name) {
            self.TEMPLATE.name = self.newTemplateName;
            self.saveTemplate({name: self.newTemplateName});
          }
          self.editTemplateName = false;
        }, 1000);
      },
      saveTemplate(updateData) {
        let self = this;
        if (self.state == 'saving') {
          return;
        }
        if (updateData == null) {
          updateData = {};
          Object.assign(updateData, self.postData);
        }

        self.state = 'saving';
        ServiceTemplate.save(self.TEMPLATE.id, updateData, template => {
          let now = new Date().getTime();
          if (now - self.updated_dtm > 5 * 1000) {
            self.$notify({
              type: 'success',
              text: 'Template updated'
            });
            self.updated_dtm = now;
          }
          self.state = '';
          self.$store.dispatch('UPDATE_TEMPLATE', template).then(() => {
            self.populateData();
          });
        }, () => {
          self.state = '';
        });
      }
    }
  }
</script>
